module.exports = __webpack_public_path__ + "static/media/Uttam_Singh_Resume.d0fd966e.pdf";